import MxRushRadioDuo, {
  MxRushRadioDuoProps
} from "@rf-l1/form/rush-field/MxRushRadioDuo";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";

type omit = "value" | "name" | "onChange" | "onBlur" | "id" | "error";
export type MxFormRushRadioDuoFieldprops = Omit<MxRushRadioDuoProps, omit>;

const MxFormRushRadioDuoField = (props: MxFormRushRadioDuoFieldprops) => {
  const { id, name, onChange, onBlur, value, invalid, disabled } =
    useMxFieldControllerContext();
  return (
    <MxRushRadioDuo
      id={id}
      items={props.items}
      label={props.label ?? ""}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      error={invalid}
      disabled={props.disabled}
    />
  );
};

export default MxFormRushRadioDuoField;
